import Loader from 'components/_UI/Loader';
import Modal from 'components/_UI/Modal'
import Radio from 'components/_UI/Radio';
import Text from 'components/_UI/Text'
import { useShowLocationModal } from 'context/general/ShowLocationModal';
import { useCurrentLocation } from 'context/user/CurrentLocation';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { useSearchParams } from 'react-router-dom';
import eventsApi from 'api/requests/events';


export default function ModalLocation({ onChangeModalLocation = () => false }) {
    const { currentLocation, setCurrentLocation } = useCurrentLocation();
    const { showLocationModal, setShowLocationModal } = useShowLocationModal();
    const [searchParams, setSearchParams] = useSearchParams();

    const [loading, setLoading] = useState(false)
    const [locations, setLocations] = useState([])

    useEffect(() => {
        getActiveLocations();
    }, []);

    async function getActiveLocations() {
        setLoading(true);
        try {
            const { data: res } = await eventsApi.getActiveLocations();
            setLocations(res?.states || []);
        } catch (error) {
            console.log('error', error);
        } finally {
            setLoading(false);
        }
    }

    function onChangeSelect(city) {
        setCurrentLocation({ city: city })
        setShowLocationModal(false)
        onChangeModalLocation({ city });
        setSearchParams(new URLSearchParams());
    }

    return (
        <Modal
            isOpen={showLocationModal}
            onClose={() => setShowLocationModal(false)}
            childrenOverflowY='scroll'
        >
            <ModalWrapper>
                <Text name='subtitle' type='bold'>
                    Escolha uma região
                </Text>
                <ContentLocation>
                    {loading ? (
                        <Loader />
                    ) : (
                        locations?.map((state) => (
                            <StateGroup key={state.code}>
                                <Text marginTop={'20px'} type='bold'>{state.name}</Text>
                                <CitiesList>
                                    {state.cities?.map((city) => (
                                        <Radio
                                            key={`${state.code}-${city.name}`}
                                            label={city.name}
                                            selected={currentLocation?.city == city.name}
                                            onSelect={() => onChangeSelect(city.name)}
                                        />
                                    ))}
                                </CitiesList>
                            </StateGroup>
                        ))
                    )}
                </ContentLocation>
            </ModalWrapper>
        </Modal>
    )
}


const ModalWrapper = styled(Column)`
    width: 100%;
    justify-content: center;
    align-items: center;
`;

const ContentLocation = styled(Column)`
    width: 100%;
    align-items: flex-start;
    padding: 0 20px;
`

const StateGroup = styled(Column)`
    width: 100%;
    align-items: flex-start;
`

const CitiesList = styled(Column)`
    width: 100%;
    align-items: flex-start;
    padding-left: 10px;
`